import { render } from "./Steps.vue?vue&type=template&id=f1b57142"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=f1b57142&lang=css"
script.render = render

export default script